import React, { FC } from "react";
import { Button, Table, Input, Tooltip, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModel";
import { RouterParamType } from "@/model/navModel";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { DetailType } from "@/types/ScmEnums";
import { formatIntPoint, formatNum } from "@/utils/utils";
import { IItemDetailList, IMaterialDetailList } from "../../chargebackTypes"
import "./index.less"
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale, technicianData } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();
    const {
        checkList,
        detailItemAddList,
        detailMaterialAddList,
        detailItemLookList,
        detailMaterialLookList,
        detailItemEditList,
        detailMaterialEditList,
        detaiItemAddDataRowKeys,
        detaiMaterialAddDataRowKeys,
        detaiItemEditDataRowKeys,
        detaiMaterialEditDataRowKeys,
        detailEditForm,
        detailAddForm,
        setDetaiMaterialEditDataRow,
        setDetaiItemAddDataRow,
        setDetaiMaterialEditDataRowKeys,
        setDetaiItemEditDataRow,
        setDetaiMaterialAddDataRow,
        setDetaiMaterialAddDataRowKeys,
        setDetaiItemAddDataRowKeys,
        setDetaiItemEditDataRowKeys,
        setCheckList,
        setItemModel,
        setMaterialModel,
        setDetailItemAddList,
        setDetailMaterialAddList,
        setDetailItemEditList,
        setDetailMaterialEditList,
        detaiItemDetailList,
        detaiMaterialDetailList,
        setMaterialHistoryModel,
        setMaterialHistoryRow
    } = useMaintenanceDetailsModel();

    const MaterialAction = mode == "look" ? <></> : <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setItemModel(true)}
        >{Locale["Add Item"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { detaiItemDetailList(mode) }}
        >{Locale["Delete Item"]}</Button>
    </>
    const ItemAction = mode == "look" ? <></> : <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => setMaterialModel(true)}
        >{Locale["Add Material"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { detaiMaterialDetailList(mode) }}
        >{Locale["Delete Material"]}</Button>
    </>
    //设置三包单位是否可选
    const emptyClaimUnit = () => {
        if (mode == "look") {
            return false
        } else if (mode == "edit" && detailEditForm.serviceNatureCode === "service-nature.three-guarantees") {
            return true
        } else if (mode == "add" && detailAddForm.serviceNatureCode === "service-nature.three-guarantees") {
            return true
        } else {
            return false
        }
    }
    const setHistoryDetail = (record: any) => {
        setMaterialHistoryRow(record)
        setMaterialHistoryModel(true)
    }
    const MaterialColumns = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '商品编码',
            title: Locale["Material Code"],
            width: 120,
            dataIndex: 'materialCode',
            fixed: "left",
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={text}><p onClick={() => setHistoryDetail(record)} className="ellipsis click-span">{text}</p></Tooltip>,
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'materialNameEn',
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '三包单位',
            title: Locale["Claim Unit"],
            width: 150,
            dataIndex: 'claimUnitCode',
            editType: "select",
            // editable: emptyClaimUnit(),
            options: getSelectedDictOne(DictCodeEnmu.CLAIMUNIT),
            // render: (t: any, record: IItemDetailList, i: number) => record.claimUnitName
            render: (t: any, record: IItemDetailList, i: number) => language == "zh-CN" ? record.claimUnitName : record.claimUnitNameEn
        }, {
            // title: '单位',
            title: Locale["Unit"],
            width: 160,
            dataIndex: 'unitName',
        }, {
            // title: '数量',
            title: Locale["Qty"],
            width: 160,
            dataIndex: 'num',
            editable: mode != "look" ? true : false,
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            width: 160,
            dataIndex: 'price',
            // editable: mode != "look" ? true : false,
        }, {
            // title: '金额',
            title: Locale["Amount"],
            width: 160,
            dataIndex: 'materialAmount',
        }, {
            // title: '折扣',
            title: Locale["Discount Rate"],
            width: 160,
            dataIndex: 'discountRate',
            // editable: mode != "look" ? true : false,
            suffix: "%",
            render: (text: string) => text + '%'
        }, {
            // title: '折后单价',
            title: Locale["Discounted Price"],
            width: 120,
            dataIndex: 'taxPrice',
        }, {
            // title: '总计',
            title: Locale["Total"],
            width: 120,
            dataIndex: 'receivableAmount',
        }, {
            // title: '仓库',
            title: Locale["Warehouse"],
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 120,
            dataIndex: 'note',
        }
    ];
    const newSelectMaterialColums = () =>
        MaterialColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })

    const handleMaterialSave = (row: IMaterialDetailList) => {
        let { num, price, discountRate, serviceNatureCode, claimUnitCode, originalNum } = row
        num = +formatIntPoint(num);  //退货数量
        price = +formatIntPoint(price);  //价格
        discountRate = +formatIntPoint(discountRate);  //折扣
        if (num > originalNum) {
            num = originalNum as number;
            message.warning('修改数量时，不能大于原单的数量');
        }
        let newRow = {
            ...row,
            materialAmount: +formatNum(num * price),
            // num: +formatIntPoint(num, inventoryNum, "选择数量≥库存数量"),
            num: num,
            receivableAmount: +formatNum((num * price * discountRate) / 100),
            taxPrice: formatNum(price * discountRate / 100),
            claimUnitName: getTreeNodeName(claimUnitCode as string),
            claimUnitNameEn: claimUnitCode && getTreeNodeOne(claimUnitCode as string).length != 0 ? getTreeNodeOne(claimUnitCode as string)[0].nameEn : "",
            serviceNatureName: getTreeNodeName(serviceNatureCode as string),
        }
        let newData = mode == "edit" ? detailMaterialEditList : detailMaterialAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode == "edit" ? setDetailMaterialEditList([...newData]) : setDetailMaterialAddList([...newData])
    }

    const newSelectItemColums = () =>
        itemColums.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IItemDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    allowClear: col.allowClear,
                    mode: col.mode,
                    handleSave: handleItemSave,
                }),
            }
        })

    const handleItemSave = (row: IItemDetailList) => {
        let { workHour, price, discountRate, originalNum, serviceNatureCode, serviceTypeCode, claimUnitCode, technicianCode } = row
        workHour = +formatIntPoint(workHour); //工时
        price = +formatIntPoint(price); //工时费 getTreeNodeName
        discountRate = +formatIntPoint(discountRate); //总计
        if (workHour > originalNum) {
            workHour = originalNum as number;
            // message.warning('修改数量时，数量×价格×折扣 不能大于对应配件的明细总计');
            message.warning('修改工时，不能大于原单的工时');
        }
        let newRow = {
            ...row,
            amount: +formatNum(workHour * price),
            serviceTypeName: getTreeNodeName(serviceTypeCode as string),
            serviceNatureName: getTreeNodeName(serviceNatureCode as string),
            claimUnitName: getTreeNodeName(claimUnitCode as string),
            taxPrice: formatNum(price * discountRate / 100),
            // claimUnitNameEn: getTreeNodeOne(claimUnitCode as string)[0].nameEn,
            claimUnitNameEn: claimUnitCode && getTreeNodeOne(claimUnitCode as string).length != 0 ? getTreeNodeOne(claimUnitCode as string)[0].nameEn : "",
            itemAmount: +formatNum(workHour * price),
            technicianName: technicianData.filter((el: any) => !!technicianCode.find((ele: any) => ele === el.code))?.map((item: any) => item.name),
            receivableAmount: +formatNum((workHour * price * discountRate) / 100),
        }
        let newData = mode == "edit" ? detailItemEditList : detailItemAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode == "edit" ? setDetailItemEditList([...newData]) : setDetailItemAddList([...newData])
    }
    const itemColums = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: "left",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            // title: '项目编码',
            title: Locale["Item Code"],
            width: 120,
            dataIndex: 'itemCode',
            fixed: "left",
        }, {
            // title: '项目名称',
            title: Locale["Item"],
            width: 120,
            dataIndex: 'itemName',
        }, {
            // title: '项目名称',
            title: Locale['ItemEn'],
            width: 120,
            dataIndex: 'itemNameEn',
        }, {
            // title: '三包单位',
            title: Locale["Claim Unit"],
            width: 150,
            dataIndex: 'claimUnitCode',
            editType: "select",
            // editable: emptyClaimUnit(),
            options: getSelectedDictOne(DictCodeEnmu.CLAIMUNIT),
            // render: (t: any, record: IItemDetailList, i: number) => record.claimUnitName
            render: (t: any, record: IItemDetailList, i: number) => language == "zh-CN" ? record.claimUnitName : record.claimUnitNameEn
        }, {
            // title: '工时数',
            title: Locale["Man-hours"],
            width: 120,
            dataIndex: 'workHour',
            editable: mode != "look" ? true : false,
        }, {
            // title: '工时单价',
            title: Locale["Unit Price"],
            width: 120,
            dataIndex: 'price',
            // editable: mode != "look" ? true : false,
        }, {
            // title: '工时费',
            title: Locale["Labor Cost"],
            width: 120,
            dataIndex: 'itemAmount',

        }, {
            // title: '折扣',
            title: Locale["Discount Rate"],
            width: 120,
            dataIndex: 'discountRate',
            // editable: mode != "look" ? true : false,
            suffix: "%",
            render: (text: string) => text + '%'
        }, {
            // title: '折后单价',
            title: Locale["Discounted Price"],
            width: 120,
            dataIndex: 'taxPrice',
        }, {
            // title: '总计',
            title: Locale["Amount"],
            width: 120,
            dataIndex: 'receivableAmount',
        }, {
            // title: '备注',
            title: Locale["Note"],
            width: 120,
            dataIndex: 'note',
        }
    ]
    const checkItem = () => {
        setCheckList(1)
    }
    const checkMaterial = () => {
        setCheckList(2)
    }
    const titleBtn = <div>
        <span className={`tabs-btn ${checkList == 1 ? 'tabs-checkColor' : ''}`} onClick={checkItem}>{Locale["Maintenance Item"]}</span>
        <span className="tabs-split"></span>
        <span className={`tabs-btn ${checkList == 2 ? 'tabs-checkColor' : ''}`} onClick={checkMaterial}>{Locale["Maintenance Material"]}</span>
    </div>
    // detailItemAddList,detailMaterialAddList,detailItemLookList,detailMaterialLookList,detailItemEditList,detailMaterialEditList
    const typeItemList = {
        "add": [...detailItemAddList],
        "edit": [...detailItemEditList],
        "look": [...detailItemLookList],
    }
    const typeMaterialList = {
        "add": [...detailMaterialAddList],
        "edit": [...detailMaterialEditList],
        "look": [...detailMaterialLookList],
    }
    //设置维修项目选中的行和数据
    const setTypeItemDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiItemAddDataRowKeys(selectedRowKeys)
        } else if (mode == DetailType.edit) {
            setDetaiItemEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeItemDetailDataRow = async (selectedRows: IItemDetailList[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiItemAddDataRow(selectedRows)
        } else if (mode == DetailType.edit) {
            setDetaiItemEditDataRow(selectedRows)
        }
    }

    //设置维修用料选中的行和数据
    const setTypeMaterialDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiMaterialAddDataRowKeys(selectedRowKeys)
        } else if (mode == DetailType.edit) {
            setDetaiMaterialEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeMaterialDetailDataRow = async (selectedRows: IMaterialDetailList[], mode: string) => {
        if (mode == DetailType.add) {
            setDetaiMaterialAddDataRow(selectedRows)
        } else if (mode == DetailType.edit) {
            setDetaiMaterialEditDataRow(selectedRows)
        }
    }
    return (
        <YhBox title={titleBtn} rightChildren={checkList == 1 ? MaterialAction : ItemAction} style={{ marginBottom: "75px" }}>
            {checkList == 1 ? <Table
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={
                    mode == "look" ? undefined : {
                        selectedRowKeys: mode == DetailType.add ? detaiItemAddDataRowKeys : detaiItemEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IItemDetailList[]) => {
                            setTypeItemDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeItemDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeItemDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectItemColums() as ColumnsType<IItemDetailList>}
                dataSource={typeItemList[mode] as IItemDetailList[]}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content' }}
            /> :
                <Table
                    rowKey={record => record.detailsId as string}
                    rowClassName='editable-row yh-edit-table-tr'
                    rowSelection={
                        mode == "look" ? undefined : {
                            selectedRowKeys: mode == DetailType.add ? detaiMaterialAddDataRowKeys : detaiMaterialEditDataRowKeys, //记录选中
                            onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetailList[]) => {
                                setTypeMaterialDetailDataRowKeysAndRow(selectedRowKeys, mode)
                                setTypeMaterialDetailDataRow(selectedRows, mode)
                            },
                            onSelectAll: (selected, selectedRows, changeRows) => {
                                setTypeMaterialDetailDataRow(selectedRows, mode)
                            }
                        }}
                    columns={newSelectMaterialColums() as ColumnsType<IMaterialDetailList>}
                    dataSource={typeMaterialList[mode] as IMaterialDetailList[]}
                    pagination={false}
                    onRow={record => ({
                        onClick: () => { }
                    })}
                    components={{
                        body: {
                            row: EditableRow,
                            cell: EditableCell,
                        },
                    }}
                    scroll={{ x: 'max-content' }}
                />}
        </YhBox>
    )
}